// extracted by mini-css-extract-plugin
export default {"MedicalContainer":"nFQwskwX"};